<script>
/**
 * The GameTabbar view works for the tabbar for the game. It looks like 
 * the app menu bar fixed on the screen bottom. It supports the 
 * dropdown menu and button menu items.
 */

//--------------------------------------------------
// imported classes
//--------------------------------------------------
import { DropdownMenu, DropdownItem, Toast, Dialog } from 'vant'
import { getPassport } from '@/libs/passport'
import { getGameUserRole,getBMGameLockListOnStage,updateBMGameLockListOnStage } from '@/api/match-team-game'
import BottomPopup from '@/components/BottomPopup'

//--------------------------------------------------
// main script
//--------------------------------------------------
export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
    name: 'game-tabbar',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        BottomPopup,
        'van-dropdown-menu': DropdownMenu,
        'van-dropdown-item': DropdownItem
    },

    //--------------------------------------------------
    // component props
    //--------------------------------------------------
	props: {
        /* The union match id string */
        unionMatchId: {
            type: String
        },
        /* The match id string */
        matchId: {
            type: String
        },
        /* The game id string */
        gameId: {
            type: String
        },
        /* The home team id string */
        homeTeamId: {
            type: String
        },
        /* The home team name string */
        homeTeamName: {
            type: String
        },
        /* The away team id string */
        awayTeamId: {
            type: String
        },
        /* The away team name string */
        awayTeamName: {
            type: String
        },
        /* The registration capability flag */
        registrationCapability: {
			type: Boolean,
			default: false
		}
	},

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
	data() {
		return {
            /* The current user roles */
            userRoles: null,
            /* The team options show flag*/
            showTeamOptions: false,
            /* The menu item trigger type flag */
            triggerType: 0
		}
	},

    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
        /**
         * @getter
         * Get the team options.
         */
        teamOptions() {
            return [
                { name: '主队：' + this.homeTeamName, value: this.homeTeamId },
                { name: '客队：' + this.awayTeamName, value: this.awayTeamId }
            ]
        },
        /**
         * @getter
         * Get the popup title.
         */
        title() {
            return '主客队选择'
        },
        /**
         * @getter
         * Get the popup description.
         */
        description() {
            if (this.triggerType == 1) {
                return '请选择球队安排出场'
            }
            else if (this.triggerType == 2) {
                return '请选择赛后确认的主客队'
            }
            else {
                return ''
            }
        }
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        //--------------------------------------------------
        // request method
        //--------------------------------------------------
        /**
         * @request
         * Query the user roles for the current game.
         * @param gameId The game id.
         * @return The reponse object.
         */
        queryGameUserRole(callback) {
            const params = {
                gameId: this.gameId
            }
            getGameUserRole(params).then(response => {
                console.log('get game user role response', response)
                const data = response.data
                this.userRoles = {
                    isMatchGameManager: data.isMatchGameManager,
                    isMatchGameReferee: data.isReferee,
                    isHomeTeamLeader: data.relationHomeTeam > 80,
                    isAwayTeamLeader: data.relationAwayTeam > 80
                }
                callback && callback()
            })
        },

        //--------------------------------------------------
        // handler method
        //--------------------------------------------------
        /**
         * @handler
         * Handle the team option select event.
         */
        onTeamOptionSelect(item, index) {
            console.log('onTeamOptionSelect', item, index)
            this.showTeamOptions = false
            console.log('MatchTeamGame', this.matchId, item.value, this.gameId)
            if (this.triggerType === 1) {
                // go to the selected team roster
                this.$router.push({ name: 'MatchTeamGameBattleArray', params: { matchId: this.matchId, teamId: item.value, gameId: this.gameId }})
            }
            else if (this.triggerType === 2) {
                // go to the selected team confirm
                this.$router.push({ 
                    name: 'MatchTeamGameConfirmation', 
                    params: { matchId: this.matchId, teamId: this.homeTeamId, gameId: this.gameId },
                    query: { role: index == 0 ? 'home' : 'away' }
                })
            }
        },
        /**
         * @handler
         * Handle the roster button click event.
         */
        onRosterBtnClick() {
            console.log('onRosterBtnClick')
            this.validateAuthentication(this.validateRosterTriggerCondition)
        },
        /**
         * @handler
         * Handle the confirm button click event.
         */
        onConfirmBtnClick() {
            console.log('onConfirmBtnClick')
            this.validateAuthentication(this.validateConfirmTriggerCondition)
        },
        /**
         * @handler
         * Handle the registration button click event.
         */
        onRegistrationBtnClick() {
            console.log('onRegistrationBtnClick', this.registrationCapability)
            this.validateAuthentication(this.validateRegistrationTriggerCondition)
        },
        /**
         * @handler
         * Handle the report button click event.
         */
        onReportBtnClick() {
            console.log('onReportBtnClick', this.registrationCapability)
            this.validateAuthentication(this.validateReportTriggerCondition)
        },
        /**
         * @handler
         * Handle the competition supervise button click event.
         */
        onCompetitionSuperviseBtnClick() {
            console.log('onCompetitionSuperviseBtnClick', this.registrationCapability)
            this.validateAuthentication(this.validateCompetitionSuperviseTriggerCondition)
        },
        /**
         * @handler
         * Handle the note button click event.
         */
        onNoteBtnClick() {
            console.log('onNoteBtnClick', this.registrationCapability)
            this.validateAuthentication(this.validateNoteTriggerCondition)
        },
        /**
         * @handler
         * Handle the event record button click event.
         */
        onEventRecordBtnClick() {
            console.log('onEventRecordBtnClick', this.registrationCapability)
            this.validateAuthentication(this.validateEventRecordTriggerCondition)
        },
        /**
         * @handler
         * Handle the score record button click event.
         */
        onScoreRecordBtnClick() {
            console.log('onScoreRecordBtnClick', this.registrationCapability)
            this.validateAuthentication(this.validateScoreRecordTriggerCondition)
        },
        
        //--------------------------------------------------
        // private method
        //--------------------------------------------------
        /**
         * @private
         * Validate the authentication.
         */
        validateAuthentication(callback) {
            getPassport().then(res => {
                console.log('getPassport', res)
                if (res) {
                    if (this.userRoles) {
                        callback && callback()
                    }
                    else {
                        this.queryGameUserRole(callback)
                    }
                }
            })
        },
        /**
         * @private
         * Validate the registration trigger condition.
         */
        validateRegistrationTriggerCondition() {
            if (!this.registrationCapability) {
                Toast('暂未开通比赛检录功能，请联系赛事组委会')
            }
            else if (this.userRoles.isMatchGameManager 
                ||  this.userRoles.isMatchGameReferee) {
                // go to the game registration
                getBMGameLockListOnStage({ gameId: this.gameId }).then(res => { 
                    const { data } = res
                    if (data.lockListOnStage == 0) {
                        console.log(1);
                        Dialog.confirm({
                            title: '提醒',
                            message: '检录前是否锁定出场安排',
                            className: 'roster-submit-dialog'
                        }).then(() => {
                            // on confirm
                            this.updateBMGameLockListOnStage()
                        })
                    } else {
                        this.$router.push({ name: 'MatchTeamGameRegistration', params: { matchId: this.matchId, gameId: this.gameId }})
                    }
                })
                // 
            }
            else {
                Toast('您不是裁判组成员，请联系赛事组委会')
            }
        },
        updateBMGameLockListOnStage() {
            updateBMGameLockListOnStage({ gameId: this.gameId, lockListOnStage: 1 }).then(res => {
                if (res) {
                    this.$router.push({ name: 'MatchTeamGameRegistration', params: { matchId: this.matchId, gameId: this.gameId }})
                }
            })
        },
        /**
         * @private
         * Validate the roster trigger condition.
         */
        validateRosterTriggerCondition() {
            if (!this.userRoles.isHomeTeamLeader && !this.userRoles.isAwayTeamLeader) {
                Toast('您不是球队管理员，请先联系领队')
            }
            else if (this.userRoles.isHomeTeamLeader 
                && this.userRoles.isAwayTeamLeader) {
                this.showTeamOptions = true
                // 1 means roster
                this.triggerType = 1
            }
            else if (this.userRoles.isHomeTeamLeader) {
                // go to the home team roster
                this.$router.push({ name: 'MatchTeamGameBattleArray', params: { matchId: this.matchId, teamId: this.homeTeamId, gameId: this.gameId }})
            }
            else if (this.userRoles.isAwayTeamLeader) {
                // go to the away team roster
                this.$router.push({ name: 'MatchTeamGameBattleArray', params: { matchId: this.matchId, teamId: this.awayTeamId, gameId: this.gameId }})
            }
        },
        /**
         * @private
         * Validate the confirm trigger condition.
         */
        validateConfirmTriggerCondition() {
            if (!this.userRoles.isHomeTeamLeader && !this.userRoles.isAwayTeamLeader) {
                Toast('您不是球队管理员，请先联系领队')
            }
            else if (this.userRoles.isHomeTeamLeader 
                && this.userRoles.isAwayTeamLeader) {
                this.showTeamOptions = true
                // 2 means confirm
                this.triggerType = 2
            }
            else if (this.userRoles.isHomeTeamLeader) {
                // go to the home team roster
                this.$router.push({ 
                    name: 'MatchTeamGameConfirmation', 
                    params: { matchId: this.matchId, teamId: this.homeTeamId, gameId: this.gameId },
                    query: { role: 'home'}
                })
            }
            else if (this.userRoles.isAwayTeamLeader) {
                // go to the away team roster
                this.$router.push({ 
                    name: 'MatchTeamGameConfirmation', 
                    params: { matchId: this.matchId, teamId: this.awayTeamId, gameId: this.gameId },
                    query: { role: 'away'}
                })
            }
        },
        /**
         * @private
         * Validate the report trigger condition.
         */
        validateReportTriggerCondition() {
            if (this.userRoles.isMatchGameManager 
                ||  this.userRoles.isMatchGameReferee) {
                // go to the game registration
                this.$router.push({ 
                    name: 'MatchTeamGameRefereeReprot', 
                    params: { matchId: this.matchId, gameId: this.gameId }, 
                    query: { role: 'referee' }
                })
            }
            else {
                Toast('您不是裁判组成员，请联系赛事组委会')
            }
        },
        /**
         * @private
         * Validate the competition supervise trigger condition.
         */
        validateCompetitionSuperviseTriggerCondition() {
            if (this.userRoles.isMatchGameManager 
                ||  this.userRoles.isMatchGameReferee) {
                // go to the game registration
                this.$router.push({ 
                    name: 'MatchTeamGameCompetitionSupervise', 
                    params: { matchId: this.matchId, gameId: this.gameId }
                })
            }
            else {
                Toast('您不是裁判组成员，请联系赛事组委会')
            }
        },
        /**
         * @private
         * Validate the note trigger condition.
         */
        validateNoteTriggerCondition() {
            if (this.userRoles.isMatchGameManager 
                ||  this.userRoles.isMatchGameReferee) {
                // go to the game registration
                this.$router.push({ 
                    name: 'MatchTeamGameRefereeNote', 
                    params: { matchId: this.matchId, gameId: this.gameId }
                })
            }
            else {
                Toast('您不是裁判组成员，请联系赛事组委会')
            }
        },
        /**
         * @private
         * Validate the event record trigger condition.
         */
        validateEventRecordTriggerCondition() {
            if (this.userRoles.isMatchGameManager 
                ||  this.userRoles.isMatchGameReferee) {
                // go to the football stats
                this.$router.push({ 
                    name: 'FootballStatistics', 
                    query: { matchId: this.matchId, id: this.gameId }
                })
            }
            else {
                Toast('您不是裁判组成员，请联系赛事组委会')
            }
        },
        /**
         * @private
         * Validate the score record trigger condition.
         */
        validateScoreRecordTriggerCondition() {
            if (this.userRoles.isMatchGameManager 
                ||  this.userRoles.isMatchGameReferee) {
                // go to the score entry
                this.$router.push({ 
                    name: 'ScoreEntry', 
                    params: { unionMatchId: this.unionMatchId },
                    query: { matchId: this.matchId, id: this.gameId }
                })
            }
            else {
                Toast('您不是裁判组成员，请联系赛事组委会')
            }
        }
    }
}
</script>

<template>
    <!-- component -->
    <div class="game-tabbar">
        <div class="tabbar-container">
            <div class="referee-section">
                <van-dropdown-menu direction="up">
                    <van-dropdown-item>
                        <template slot="title">
                            <div class="btn btn-bottom referee-btn">
                                <span class="icon-holder"></span>
                                <span class="label">裁判专区</span>
                            </div>
                            <div class="indicator">
                                <span class="indicator-holder"></span>
                            </div>
                        </template>
                        <div class="item-cell" @click="onNoteBtnClick">
                            <div class="cell-wrapper">
                                <img src="@/assets/match-team-game/note-icon.svg"/>
                                <span class="label">特别备注</span>
                            </div>  
                        </div>
                        <div class="item-cell" @click="onCompetitionSuperviseBtnClick">
                            <div class="cell-wrapper">
                                <img src="@/assets/match-team-game/note-icon.svg"/>
                                <span class="label">比赛监督</span>
                            </div>  
                        </div>
                        <div class="item-cell" @click="onReportBtnClick">
                            <div class="cell-wrapper">
                                <img src="@/assets/match-team-game/report-icon.svg"/>
                                <span class="label">裁判报告</span>
                            </div>
                        </div>
                        <div class="item-cell" @click="onEventRecordBtnClick">
                            <div class="cell-wrapper">
                                <img src="@/assets/match-team-game/record-icon.svg"/>
                                <span class="label">事件记录</span>
                            </div>
                        </div>
                        <div class="item-cell" @click="onScoreRecordBtnClick">
                            <div class="cell-wrapper">
                                <img src="@/assets/match-team-game/note-icon.svg"/>
                                <span class="label">比分录入</span>
                            </div>
                        </div>
                        <div class="item-cell" @click="onRegistrationBtnClick">
                            <div class="cell-wrapper">
                                <img src="@/assets/match-team-game/reg-icon.svg"/>
                                <span class="label">比赛检录</span>
                            </div>
                        </div>
                    </van-dropdown-item>
                </van-dropdown-menu>
            </div>
            <div class="separator-section">
                <span class="separator"></span>
            </div>
            <div class="leader-section">
                <div class="btn btn-bottom confirm-btn" @click="onConfirmBtnClick">
                    <!--<img class="icon" src="@/assets/match-team-game/post-match-confirm-icon.svg"/>-->
                    <span class="icon-holder"></span>
                    <span class="label">赛后确认</span>
                </div>
                <div class="btn btn-bottom roster-btn" @click="onRosterBtnClick">
                    <!--<img class="icon" src="@/assets/match-team-game/roster-icon.svg"/>-->
                    <span class="icon-holder"></span>
                    <span class="label">出场安排</span>
                </div>
            </div>
        </div>
        <bottom-popup
            :showPopup="showTeamOptions"
            :options="teamOptions"
            :title="title"
            :description="description"
            @select-option="onTeamOptionSelect"
            @close-popup="showTeamOptions = false">
        </bottom-popup>
    </div>
</template>

<style>
.game-tabbar .referee-section .van-overlay {
    background: none;
}
.game-tabbar .referee-section .van-dropdown-menu__title::after {
	content: none;
}
.game-tabbar .referee-section .van-dropdown-menu__bar {
    box-shadow: none;
}
.game-tabbar .referee-section .van-dropdown-menu__item {
    width: 118px;
}
.game-tabbar .referee-section .van-dropdown-item__content {
    margin-left: 5px;
    width: 113px;
    padding-bottom: 12px;
    border-radius: 6px 6px 0 0;
    background: #EBFAF6;
    box-sizing: border-box;
    border: 1px solid #EFF0F1;
}
</style>
<style scoped>
.game-tabbar {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 50px;
    background: #FFFFFF;
    box-sizing: border-box;
    border-width: 1px 0px 0px 0px;
    border-style: solid;
    border-color: #F0F0F3;
}
.btn {
    width: 46px;
    height: 42px;
    display: inline-block;
}
.icon {
    display: block;
    margin-left: auto;
    margin-right: auto;
}
.label {
    display: block;
    font-family: Source Han Sans;
    font-size: 11px;
    font-weight: 350;
    line-height: normal;
    letter-spacing: normal;
    color: #3D3D3D;
}
.van-dropdown-menu__title--active .label {
    color: #0FAC7F;
}
.icon-holder {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 32px;
    height: 32px;
    margin-bottom: 0;
    padding-bottom: 0;
}
.referee-btn .icon-holder {
    background: url('../../assets/match-team-game/referee-icon.svg') no-repeat;
}
.confirm-btn .icon-holder {
    background: url('../../assets/match-team-game/post-match-confirm-icon.svg') no-repeat;
}
.roster-btn .icon-holder {
    background: url('../../assets/match-team-game/roster-icon.svg') no-repeat;
}
.van-dropdown-menu__title--active .referee-btn .icon-holder {
    background: url('../../assets/match-team-game/referee-icon-fill.svg') no-repeat;
}
.indicator-holder {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 15px;
    height: 14px;
    background: url('../../assets/match-team-game/down-indicator.svg') no-repeat;
}
.van-dropdown-menu__title--active .indicator-holder {
    background: url('../../assets/match-team-game/up-indicator.svg') no-repeat;
}
.referee-section {
    display: inline-block;
    position: relative;
    width: 118px;
    height: 50px;
    bottom: 6px;
}

.referee-btn {
    margin: 0px 9px 2px;
    position: relative;
}
.indicator {
    display: inline-block;
    position: relative;
    bottom: 14px;
}

.cell-wrapper {
    height: 20px;
    padding: 14px 16px;
}
.cell-wrapper * {
    display: inline-block;
}
.cell-wrapper .label {
    margin-left: 7px;
    font-family: Source Han Sans;
    font-size: 12px;
    font-weight: 350;
    line-height: 12px;
    letter-spacing: normal;
    text-align: center;
    color: #1D2129;
    bottom: 5px;
    position: relative;
}
.btn-bottom .label {
    position: absolute;
    bottom: 4px;
}
.referee-btn .label {
    bottom: -2px !important;
}
.tabbar-container {
    margin-top: 0px;
    padding-top: 0px;
}
.leader-section {
    display: inline-block;
    float: right;
    margin-right: 20px;
}
.leader-section .btn + .btn {
    margin-left: 42px;
}
.separator-section {
    display: inline-block;
}
.separator {
    margin: 13px 0;
    border-left: 1px solid #F0F0F3;
    height: 24px;
    display: block;
}
</style>